import { createSelector } from 'reselect';
import { getPractices } from '../practices'

export function getPracticeList(state) {
  return state.practicelists;
}

export function getPracticeListById(state, searchId) {
  return getPracticeList(state).get(searchId);
}

//=====================================
//  MEMOIZED SELECTORS
//-------------------------------------

export const getCurrentPracticeList = createSelector(
  getPracticeList,
  practicelists => practicelists.get(practicelists.get('currentPracticeListId'))
);

export const getPracticesForCurrentPracticeList = createSelector(
  getCurrentPracticeList,
  getPractices,
  ( practicelists, practices) => {
    return practicelists.practiceIds.map( id => practices.get(id) );
  }
);
